/** Libellé de rôle à partir des clés `StatsSection.json` → `roles.*` */
export function roleLabelFromStatsT(rolesId: number | undefined, t: (key: string) => string): string {
  const id = rolesId ?? 0;
  const key = `roles.r${id}`;
  const label = t(key);
  if (label !== key) return label;
  return t('roles.unknown');
}
